import * as Sentry from '@sentry/react';
import { getEnvironment } from 'utilities/environment';

/*
 * This Sentry configuration is currently unused. We initialize Sentry
 * using exception_reporter.js.es6, loaded through packs/application.js.
 * TODO: consider moving initialization to this file and closer to how it is
 * done in https://docs.sentry.io/platforms/javascript/guides/react/.
 */

const DSN = {
  // solidshop-fe
  production: 'https://5204f172ebe54d7bbe5b41a731cd17be@sentry.io/5778127',
  // solidshop-fe-staging
  staging: 'https://4dc1c56aff3641d3a23a53d683855546@sentry.io/5778133',
};

const envConfig = getEnvironment();

if (envConfig) {
  Sentry.init({
    dsn: DSN[envConfig.env],
    environment: envConfig.env,
    ignoreErrors: [
      // Random plugins/extensions
      'top.GLOBALS',
      // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
      'originalCreateNotification',
      'canvas.contentDocument',
      'MyApp_RemoveAllHighlights',
      'http://tt.epicplay.com',
      "Can't find variable: ZiteReader",
      'jigsaw is not defined',
      'ComboSearch is not defined',
      'http://loading.retry.widdit.com/',
      'atomicFindClose',
      // Facebook borked
      'fb_xd_fragment',
      // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to
      // reduce this. (thanks @acdha)
      // See http://stackoverflow.com/questions/4113268
      'bmi_SafeAddOnload',
      'EBCallBackMessageReceived',
      // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
      'conduitPage',
    ],
    denyUrls: [
      // Facebook flakiness
      /graph\.facebook\.com/i,
      // Facebook blocked
      /connect\.facebook\.net\/en_us\/all\.js/i,
      // Woopra flakiness
      /eatdifferent\.com\.woopra-ns\.com/i,
      /static\.woopra\.com\/js\/woopra\.js/i,
      // Chrome extensions
      /extensions\//i,
      /^chrome:\/\//i,
      // Other plugins
      /127\.0\.0\.1:4001\/isrunning/i, // Cacaoweb
      /webappstoolbarba\.texthelp\.com\//i,
      /metrics\.itunes\.apple\.com\.edgesuite\.net\//i,
    ],
    beforeSend: (event) => {
      if (!window.Sq?.OneTrust?.analyticsTrackingEnabled) {
        return event;
      }

      return null;
    },
  });

  const diagnosticData = window.Sq?.Shop?.Utils?.diagnosticData();
  if (diagnosticData) {
    Sentry.configureScope((scope) => {
      scope.setContext('diagnostics', diagnosticData);
    });
  }
}
